import { createBrowserRouter } from 'react-router'
import App from '../App'
import homeRoutes from '../home/routes'
import PageNotFound from '../errors/PageNotFound'
import supplierRoutes from '../suppliers/routes'

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [...homeRoutes, ...supplierRoutes]
  },
  {
    path: '*',
    element: <PageNotFound />
  }
])

export default router
